import { useIntl } from 'react-intl';

import type { IDriver } from '@/modules/driver/model/driver';
import { CountryCode, TCountryCodes } from '@/shared/models/country-code';
import { DocsList, IDocsListItem } from '@src-common/view/components/DocsList';

import { DriverPartnerContract } from './DriverPartnerContract';

interface IProps<T extends IDocsListItem> {
  driver: IDriver;
  docs: T[];
  onUploadDoc: (event: React.SyntheticEvent, document: T) => void;
  region: TCountryCodes;
  onChangeContract: (isContractValid: boolean) => void;
}

const Docs = <T extends IDocsListItem>({
  driver,
  docs,
  onUploadDoc,
  region,
  onChangeContract,
}: IProps<T>) => {
  const intl = useIntl();

  return (
    <>
      <DocsList<T>
        title={intl.formatMessage({
          defaultMessage: 'DOCUMENTS',
          id: 'wVBktP',
          description: 'Docs list title',
        })}
        onChange={onUploadDoc}
        docs={docs}
        scrollToView={false}
      />
      {region === CountryCode.Russia && (
        <DriverPartnerContract
          value={driver.hasContractWithPartner}
          name={'hasContractWithPartner'}
          onChange={onChangeContract}
        />
      )}
    </>
  );
};

export type { IProps };
export { Docs };
